module.exports = __webpack_public_path__ + "img/unnamed.07f2e4af.png";